import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, Row } from 'reactstrap';
import LargestCol from 'components/LargestCol';
import WaitlistReasonSelect from 'components/WaitlistReasonSelect';
import Label from 'components/Input/Label';
import Button from 'components/Button';

const TextArea = styled.textarea`
  width: 100%;
  resize: none;
  min-height: 8rem;
`;

const StyledLabel = styled(Label)`
  color: ${props => props.theme.colors.white};
`;

const StyledButton = styled(Button)`
  font-size: 0.75rem;
  /* Required to override the button custom styling */
  padding: 0.5rem 1rem !important;
  background-color: ${props => props.theme.tabs.backgroundColor};
`;

const StyledRow = styled(Row)`
  margin: 0 1.25rem;

  @media screen and (max-width: ${props =>
      props.theme.breakpoints.extraSmall}) {
    margin: 0 0.1rem;
  }
`;

class WaitlistForm extends Component {
  handleWaitListReason = reason => {
    const { setWaitListBookingReason, setIsWaitListBooking } = this.props;
    setWaitListBookingReason(reason);
    setIsWaitListBooking(true);
  };

  clearWaitlistRequest = () => {
    const {
      setWaitListBookingReason,
      setWaitListBookingComment,
      setIsWaitListBooking
    } = this.props;

    setWaitListBookingReason(null);
    setWaitListBookingComment('');
    setIsWaitListBooking(false);
  };

  render() {
    const {
      waitListBookingComment,
      setWaitListBookingComment,
      waitListBookingReason
    } = this.props;

    return (
      <StyledRow>
        <LargestCol sm={12}>
          <FormGroup>
            <StyledLabel htmlFor="waitListBookingReason">
              REASON FOR WAITLIST REQUEST
            </StyledLabel>
            <WaitlistReasonSelect
              id={'waitListBookingReason'}
              value={waitListBookingReason}
              onChange={this.handleWaitListReason}
            />
          </FormGroup>
        </LargestCol>
        <LargestCol sm={12} className={'mt-3'}>
          <FormGroup>
            <StyledLabel htmlFor="waitListBookingComment">
              WAITLIST REQUEST COMMENTS
            </StyledLabel>
            <TextArea
              id={'waitListBookingComment'}
              value={waitListBookingComment}
              onChange={e => setWaitListBookingComment(e.target.value)}
            />
          </FormGroup>
        </LargestCol>
        <LargestCol sm={12}>
          <StyledButton
            className={'float-right'}
            onClick={this.clearWaitlistRequest}
          >
            CLEAR
          </StyledButton>
        </LargestCol>
      </StyledRow>
    );
  }
}

WaitlistForm.propTypes = {
  setWaitListBookingReason: PropTypes.func.isRequired,
  waitListBookingReason: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  waitListBookingComment: PropTypes.string,
  setWaitListBookingComment: PropTypes.func.isRequired,
  setIsWaitListBooking: PropTypes.func.isRequired
};

export default WaitlistForm;
